/**
 * Convert a string to Title Case while preserving known uppercase abbreviations.
 * Examples: "bmw x5 m sport" => "BMW X5 M Sport"
 *           "FORD FOCUS" => "Ford Focus"
 */
const UPPERCASE_WORDS = new Set([
  "BMW", "AMG", "RS", "GT", "GTI", "GTE", "GTD", "SE", "ST", "VW",
  "SUV", "MPV", "TDI", "TSI", "TFSI", "HDI", "CDTI", "THP", "AWD",
  "4WD", "M", "S", "R", "X", "Q", "A", "C", "E", "GLC", "GLE",
  "GLA", "CLA", "GLB", "EQC", "XC", "V8", "V6", "V12", "I3", "I4",
  "I5", "I6", "I8", "X1", "X2", "X3", "X4", "X5", "X6", "X7",
  "A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "Q2", "Q3",
  "Q5", "Q7", "Q8", "TT", "RS3", "RS4", "RS5", "RS6", "RS7",
  "S3", "S4", "S5", "S6", "S7", "S8", "SQ5", "SQ7", "SQ8",
  "ID", "MG", "DS", "JCW", "FR", "DSG", "AUDI", "MINI", "FIAT", "SEAT", "BYD"
]);

export function toTitleCase(str) {
  if (!str) return "";
  return str
    .split(/([ -])/)
    .map((word) => {
      if (word === " " || word === "-") return word;
      const upper = word.toUpperCase();
      if (UPPERCASE_WORDS.has(upper)) return upper;
      if (word.length <= 1) return word.toUpperCase();
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join("");
}

/**
 * Format car name from make, model, and optional variant.
 */
export function formatCarName(make, model, variant) {
  const parts = [make, model, variant].filter(Boolean);
  return toTitleCase(parts.join(" "));
}
